var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProtect(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10072",
    "data-name": "Group 10072",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26.234,
    height: 29.852,
    viewBox: "0 0 26.234 29.852",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4831",
    "data-name": "Rectangle 4831",
    width: 26.234,
    height: 29.852,
    fill: "#d13c3c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10071",
    "data-name": "Group 10071",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5661",
    "data-name": "Path 5661",
    d: "M13.177,0A20.523,20.523,0,0,0,26.136,3.53l.1.9,0,3.613a24.578,24.578,0,0,1-.321,3.944c-1.218,7.758-6.083,13.962-12.79,17.863A25.078,25.078,0,0,1,.341,12.089,24.975,24.975,0,0,1,0,8.044L0,3.568l2.111.01A20.292,20.292,0,0,0,13.07,0Zm-.054,25.855a23.791,23.791,0,0,0,6.66-7.234A21.129,21.129,0,0,0,22.722,6.992a23.171,23.171,0,0,1-9.6-2.969A23.31,23.31,0,0,1,4.357,6.9L3.5,7.056A25.462,25.462,0,0,0,3.625,10.2a21.729,21.729,0,0,0,9.5,15.651",
    transform: "translate(0 -0.001)",
    fill: "#d13c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5662",
    "data-name": "Path 5662",
    d: "M12.674,23.181A19.956,19.956,0,0,1,4.814,8.037,24.872,24.872,0,0,0,12.67,5.5a24.782,24.782,0,0,0,7.86,2.535,19.966,19.966,0,0,1-7.856,15.15m-4.11-9L11.8,17.416l5.862-5.863-1.23-1.238L11.8,14.946,9.785,12.938Z",
    transform: "translate(0.448 0.511)",
    fill: "#d13c3c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtect);
export default __webpack_public_path__ + "static/media/protect.a07b8597e020d9caa2f4eea6bdc98372.svg";
export { ForwardRef as ReactComponent };